import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { ConfigProvider, theme } from "antd";

import AuthGate from "./components/AuthGate";
import AppLayout from "./layouts/DefaultLayout";
import Applications from "./pages/Applications";
import ApplicationsDetails from "./pages/Applications/components/ApplicationDetails";
import AdminPage from "pages/Admin";

const { defaultAlgorithm, darkAlgorithm } = theme;
function App() {
  const isDarkMode = false;
  return (
    <ConfigProvider
      theme={{
        algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
        token: {
          // seed tokens
          borderRadius: 12,
          colorPrimary: "#005DA9",
          // colorInfo: "#005DA9", -- too dark for theme to fir properly
          colorSuccess: "#ACE8B1",
          colorError: "#D93B30",

          colorInfo: "#005DA9",
          fontSize: 16,
          fontSizeHeading1: 64,
          fontSizeHeading2: 48,
          fontSizeHeading3: 36,
          fontWeightStrong: 700,
          fontFamily: "'Proxima Nova', 'Segoe UI', 'Helvatica', sans-serif",

          // map tokens
          colorTextBase: isDarkMode ? "#F1F1F1" : "#49443D",
          colorTextHeading: isDarkMode ? "#F1F1F1" : "#49443D",
          colorText: isDarkMode ? "#F1F1F1" : "#272520", // Light Grey / Black
          colorButtonContainer: isDarkMode ? "#272520" : "#F1F1F1", // Black / Light Grey
          colorBgElevated: isDarkMode ? "#1F1B18" : "#F1F1F1",
          colorBorder: isDarkMode ? "#3A3532" : "rgba(0, 0, 0, 0.2)",
          colorBorderSecondary: isDarkMode ? "#3A3532" : "rgba(0, 0, 0, 0.2)",
          colorTextSecondary: isDarkMode ? "#B0B0B0" : "rgba(0, 0, 0, 0.65)",
          colorTextTertiary: isDarkMode ? "#8A8A8A" : "rgba(0, 0, 0, 0.45)",
          lineWidth: 1,
        },
        components: {
          Grid: {
            colorBgBase: isDarkMode ? "#272520" : "#F1F1F1",
          },
          Layout: {
            siderBg: isDarkMode ? "#1F1B18" : "#F1F1F1",
            lightSiderBg: isDarkMode ? "#272520" : "#F1F1F1",
            colorBgLayout: isDarkMode ? "#1F1B18" : "#F1F1F1",
          },
          Menu: {
            itemBg: isDarkMode ? "#1F1B18" : "#F1F1F1",
            darkItemBg: isDarkMode ? "#272520" : "#F1F1F1",
          },
          Button: {
            defaultBg: isDarkMode ? "#272520" : "#F1F1F1",
            defaultBorderColor: isDarkMode ? "#3A3532" : "rgba(0, 0, 0, 0.2)",
            borderRadius: 12,
          },
          Table: {
            borderRadius: 12,
          },
          Segmented: {
            itemActiveBg: isDarkMode ? "#005DA9" : "#005DA9",
            itemBg: isDarkMode ? "#1F1B18" : "#FFFFFF",
            itemSelectedBg: isDarkMode ? "#005DA9" : "#FFFFFF",
            trackBg: isDarkMode ? "#272520" : "#F1F1F1",
            trackPadding: 4,
          },
        },
      }}
    >
      <div
        style={{
          backgroundColor: isDarkMode ? "#272520" : "#F1F1F1",
          height: "100vh",
        }}
      >
        <Router>
          <AuthGate>
            <Routes>
              <Route
                path="/"
                element={<Navigate replace to="/applications" />}
              />
              <Route path="*" element={<AppLayout />}>
                <Route path="applications" element={<Applications />}>
                  <Route
                    path=":application_id"
                    element={<ApplicationsDetails />}
                  />
                </Route>
                <Route path="admin" element={<AdminPage />} />
              </Route>
            </Routes>
          </AuthGate>
        </Router>
      </div>
    </ConfigProvider>
  );
}

export default App;
